import React, { useState } from "react";
import "../Footer/Footer.css";
import logo from "../../assets/INX_DIGITAL_LOGO_DESIGN0.png";
import instagram from "../Images/instagram-fill.png";
import x from "../Images/prime_twitter.png";
import facebook from "../Images/uil_facebook.png";
import linkedin from "../Images/mdi_linkedin.png";

const Footer = () => {
  const [openTerms, setOpenTerms] = useState(false);
  const [openPrivacy, setOpenPrivacy] = useState(false);

  return (
    <>
      <div className="footer-container">
        <div className="topizzy">
          <div className="top">
            <div className="logo">
              <img src={logo} alt="" className="logo-img" />{" "}
              <span className="rc-number">RC: 8193592</span>
            </div>
            <div className="socials">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.instagram.com/inxdigitalsltd/"
              >
                <img src={instagram} alt="" className="ig social-icon" />
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://x.com/inxdigitalsltd"
              >
                <img src={x} alt="" className="twitter social-icon" />
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.facebook.com/inxdigitals/"
              >
                <img src={facebook} alt="" className="fb social-icon" />
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.linkedin.com/company/inxdigitals/?viewAsMember=true"
              >
                <img src={linkedin} alt="" className="linkedin social-icon" />
              </a>
            </div>
          </div>
          <div className="right-top">
            <p>LINKS:</p>
            <div className="top-2">
              <a href="#">Home</a>
              <a href="#ourService">Our Services</a>
              <a href="#aboutUs">About Us</a>
              <a href="">
                Skillspoint
                <span className="coming-soon">Soon</span>
              </a>
            </div>
          </div>
        </div>

        <div className="border-line"></div>

        <div className="reach-us">
          <p className="address">
            Contact address: 4, Segilola Street, Agege, Lagos State, Nigeria.
          </p>
          <p className="numbers">
            Phone & WhatsApp: <a href="tel:+2348109511164">+234 810 951 1164</a>
          </p>
        </div>

        <div className="copyright">
          <span>© 2025 . All Rights Reserved by INX DIGITALS LTD.</span>

          <div className="links">
            <p
              style={{
                cursor: "pointer",
                textDecoration: "underline",
                textAlign: "left",
              }}
              onClick={() => setOpenTerms(true)}
            >
              Refund Policy
            </p>

            <p
              style={{
                cursor: "pointer",
                textDecoration: "underline",
                marginLeft: "20px",
                textAlign: "left",
              }}
              onClick={() => setOpenPrivacy(true)}
            >
              Privacy Policy
            </p>
          </div>
        </div>
      </div>

      {/* REFUND POLICY MODAL */}
      {openTerms && (
        <div className="tos-backdrop" onClick={() => setOpenTerms(false)}>
          <div
            className="tos-modal"
            onClick={(e) => e.stopPropagation()} // prevents closing when clicking inside
          >
            <button className="close-btn" onClick={() => setOpenTerms(false)}>
              ✕
            </button>

            <h2>INX Digitals Ltd — Refund & Cancellation Policy</h2>
            <div className="tos-content">
              <p>
                At INX Digitals Ltd, we are committed to delivering high-quality
                digital services and ensuring client satisfaction. This Refund &
                Cancellation Policy outlines the terms under which refunds,
                cancellations, and project adjustments may be granted.
              </p>
              <ol>
                <li>
                  Project Deposits
                  <ul>
                    <li>
                      All projects require an upfront or full deposit depending
                      on nature of project to be carried out.
                    </li>
                    <li>
                      Deposits are non-refundable, as they cover initial
                      consultations, planning, resource allocation, and
                      administrative costs.{" "}
                    </li>
                  </ul>
                </li>
                <li>
                  Refund Eligibility
                  <br />
                  <span>
                    Refunds may be considered under the following conditions:
                  </span>
                  <ul>
                    <li>
                      No Work Initiated: If INX Digitals Ltd has not yet
                      commenced any work on the project, the client may request
                      a partial refund (excluding the non-refundable deposit).
                    </li>
                    <li>
                      INX Digitals Ltd Unable to Deliver: If due to internal
                      limitations INX Digitals Ltd is unable to execute the
                      project after payment, the client will receive a full
                      refund, including the deposit.
                    </li>
                  </ul>
                </li>
                <li>
                  Non-Refundable Situations
                  <br />
                  <span>
                    Refunds will not be granted in the following cases:
                  </span>
                  <ul>
                    <li>Client changes their mind after work has begun.</li>
                    <li>
                      Project delays caused by the client (late feedback,
                      incomplete materials, unresponsive communication).
                    </li>
                    <li>
                      Client requests additional features outside the agreed
                      scope.
                    </li>
                    <li>
                      Client fails to provide required materials within the
                      agreed time frame.
                    </li>
                    <li>
                      Work has already been completed or substantially completed
                      as per the scope of work.
                    </li>
                  </ul>
                </li>
                <li>
                  Cancellation Requests
                  <ul>
                    <li>
                      All cancellation requests must be submitted in writing to
                      admin@inxdigitals.com.
                    </li>
                    <li>
                      Upon cancellation, all completed work to date will be
                      delivered to the client, and any outstanding balance for
                      work already completed will still be payable but refund
                      for payment already made will not be carried out
                    </li>
                  </ul>
                </li>
                <li>
                  Service-Specific Refund Terms
                  <ul>
                    <li>
                      Website Development & Design
                      <br />- Once project is started, refunds are no longer
                      applicable.
                    </li>
                    <li>
                      Branding & Graphic Design :All concept development fees
                      are non-refundable.
                    </li>
                    <li>
                      Digital Marketing :Marketing retainers, ads management,
                      and monthly subscriptions are non-refundable once the
                      cycle begins.
                    </li>
                    <li>
                      Consultation Services :Consultation fees are fully
                      non-refundable once the session is started.
                    </li>
                  </ul>
                </li>
                <li>
                  Timelines for Refund Processing
                  <br /> Approved refunds will be processed within 7–14 business
                  days via the original payment method unless otherwise agreed.
                </li>
                <li>
                  Dispute Resolution
                  <br />
                  If any disagreement arises concerning the refund process, both
                  parties agree to resolve the issue through communication and
                  mediation before considering legal action.
                </li>
                <li>
                  Acceptance of Policy By making payment for a service with INX
                  Digitals Ltd, the client acknowledges and agrees to the terms
                  of this Refund & Cancellation Policy.
                </li>
              </ol>
            </div>
          </div>
        </div>
      )}

      {/* PRIVACY POLICY MODAL */}
      {openPrivacy && (
        <div className="tos-backdrop" onClick={() => setOpenPrivacy(false)}>
          <div className="tos-modal" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setOpenPrivacy(false)}>
              ✕
            </button>

            <h2>INX Digitals Ltd — Privacy Policy</h2>
            <div className="tos-content">
              <p>
                INX Digitals Limited (“INX Digitals,” “we,” “our,” or “us”) is
                committed to protecting your privacy. This Privacy Policy
                explains how we collect, use, store, and protect your personal
                information when you visit our website, use our services, or
                interact with our digital platforms.
                <br /> <br />
                By accessing our website or using our services, you agree to the
                terms outlined in this Privacy Policy.
              </p>

              <ol>
                <li>
                  Information We Collect
                  <ul>
                    <li>
                      Information You Provide - We may collect personal
                      information that you voluntarily provide, including:
                      <ul>
                        <li>Name</li>
                        <li>Email Address</li>
                        <li>Phone Number</li>
                        <li>Company Information</li>
                        <li>Project or Inquiry Details</li>
                        <li>
                          Payment information (handled through secure
                          third-party processors)
                        </li>
                      </ul>
                    </li>
                    <br />
                    <li>
                      Information Collected Automatically - When you visit our
                      website, we may automatically collect:
                      <ul>
                        <li>IP Address</li>
                        <li>Browser type and device information</li>
                        <li>Pages viewed and actions taken on the website</li>
                        <li>Cookies and similar technologies</li>
                        <li>Referring website links</li>
                      </ul>
                    </li>
                    <br />
                    <li>
                      Information from Third Parties - We may receive
                      information from:
                      <ul>
                        <li>Marketing platforms</li>
                        <li>Advertising networks</li>
                        <li>Payment processors</li>
                        <li>Analytics tools (e.g., Google Analytics)</li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <br />
                <li>
                  How We Use Your Information - INX Digitals uses collected
                  information to:
                  <ul>
                    <li>Provide and improve our services</li>
                    <li>Respond to inquiries and offer customer support</li>
                    <li>Process payments and manage projects</li>
                    <li>
                      Send updates, newsletters, and promotional materials
                    </li>
                    <li>Improve website functionality and monitor analytics</li>
                    <li>Maintain security and prevent unauthorized access</li>
                  </ul>
                </li>
                <br />
                <li>
                  Legal Basis for Processing (For GDPR Regions) - We may process
                  your data on the basis of:
                  <ul>
                    <li>Your Consent</li>
                    <li>Contractual Necessity</li>
                    <li>Legitimate Business Interests</li>
                    <li>Compliance with Legal Obligations</li>
                  </ul>
                </li>
                <br />
                <li>
                  Cookies and Tracking Technologies <br /> Our website uses
                  cookies to:
                  <ul>
                    <li>Enhance user experience</li>
                    <li>Enable website functionality</li>
                    <li>Analyze browsing behavior</li>
                    <li>Provide targeted advertising</li>
                  </ul>
                  You can manage or disable cookies through your browser
                  settings.
                </li>
                <br />
                <li>
                  How We Share Your Information
                  <br />
                  We do not sell your data. However, we may share information
                  with trusted third parties such as:
                  <ul>
                    <li>Payment processors</li>
                    <li>Hosting providers</li>
                    <li>Email marketing platforms</li>
                    <li>Analytics and tracking tools</li>
                    <li>
                      Contracted developers or service partners working on your
                      project
                    </li>
                  </ul>
                  All third parties are required to maintain data
                  confidentiality.
                </li>
                <br />
                <li>
                  Data Storage & Security
                  <br />
                  We implement industry-standard security measures to protect
                  your data from:
                  <ul>
                    <li>Loss</li>
                    <li>Misuse</li>
                    <li>Unauthorized Access</li>
                    <li>Modification</li>
                    <li>Disclosure</li>
                  </ul>
                </li>
                <br />
                <li>
                  Data Retention
                  <br />
                  We retain personal information only for as long as necessary
                  to:
                  <ul>
                    <li>Fulfill the purposes stated</li>
                    <li>Meet legal obligations</li>
                    <li>Resolve disputes</li>
                    <li>Enforce agreements</li>
                  </ul>
                  When data is no longer needed, it is securely deleted.
                </li>
                <br />
                <li>
                  Your Rights
                  <br />
                  Depending on your location, you may have rights to:
                  <ul>
                    <li>Access your personal data</li>
                    <li>Update or correct information</li>
                    <li>Request deletion</li>
                    <li>Withdraw consent</li>
                    <li>Opt out of making communications</li>
                    <li>Request data portability</li>
                  </ul>
                  To exercise these rights, contact us via the details below.
                </li>
                <br />
                <li>
                  Third-Party Links
                  <br /> Our website may contain links to external sites. We are
                  not responsible for the privacy practices of these third
                  parties.
                </li>
                <br />
                <li>
                  Children’s Privacy <br /> Our services are not directed at
                  children under 13. We do not knowingly collect information
                  from minors.
                </li>
                <br />
                <li>
                  Changes to This Privacy Policy <br /> We may update this
                  Privacy Policy periodically. We will notify users by updating
                  the “Last Updated” date at the top of this page.
                </li>
                <li>
                  Contact Information <br /> For questions, concerns, or
                  requests regarding this Privacy Policy, contact us at:
                  info@inxdigitals.com
                </li>
              </ol>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Footer;
